function setLoads(data) {
	return {
		type: 'SET_LOADS',
		payload: data,
	};
}

export { setLoads };
